"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var Observable_1 = require("rxjs/Observable");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var custom_aggregate_functions_provider_service_1 = require("../../../api/summary-pages/custom-aggregate/custom-aggregate-functions-provider.service");
var operators_1 = require("rxjs/operators");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var idm_locale_service_client_js_1 = require("@synisys/idm-locale-service-client-js");
var core_1 = require("@angular/core");
var CustomAggregateFunctionsProviderImplService = /** @class */ (function () {
    function CustomAggregateFunctionsProviderImplService(localeService, currentLanguageProvider) {
        this.localeService = localeService;
        this.currentLanguageProvider = currentLanguageProvider;
        this.currentLanguageId$ = this.currentLanguageProvider.getCurrentLanguage().pipe(operators_1.map(function (language) { return language.getId(); }), operators_1.shareReplay(1));
    }
    CustomAggregateFunctionsProviderImplService.prototype.getCustomAggregateFunctions = function (category) {
        var count = {
            key: 'ejustice_count',
            title: 'ejustice_count'
        };
        var max = {
            key: 'ejustice_max',
            title: 'ejustice_max',
            appliedToFieldTypes: [idm_kb_service_client_js_1.MetaFieldType.INTEGER, idm_kb_service_client_js_1.MetaFieldType.BOOLEAN,
                idm_kb_service_client_js_1.MetaFieldType.DATE, idm_kb_service_client_js_1.MetaFieldType.DATE_TIME, idm_kb_service_client_js_1.MetaFieldType.STRING]
        };
        var min = {
            key: 'ejustice_min',
            title: 'ejustice_min',
            appliedToFieldTypes: max.appliedToFieldTypes
        };
        var printConcat = {
            key: 'ejustice_print_field_concat',
            title: 'ejustice_print_field_concat',
            appliedToFieldTypes: [idm_kb_service_client_js_1.MetaFieldType.MAIN_ENTITY, idm_kb_service_client_js_1.MetaFieldType.CLASSIFIER]
        };
        return Observable_1.Observable.of([count, max, min, printConcat]);
    };
    CustomAggregateFunctionsProviderImplService.prototype.calculate = function (functionKey, category, rootCategory, entities, aggregateConfig, groupingFieldValue) {
        var result = {
            value: '',
            title: custom_aggregate_functions_provider_service_1.CustomAggregateFunctionsProviderService.getDefaultTitle(functionKey, category, aggregateConfig, groupingFieldValue),
            hideValue: false
        };
        switch (functionKey) {
            case 'ejustice_max':
                return this.loadMaxMin(result, entities, aggregateConfig, true);
            case 'ejustice_min':
                return this.loadMaxMin(result, entities, aggregateConfig, false);
            case 'ejustice_count':
                result.value = !entities ? '0' : entities.length.toString();
                break;
            case 'ejustice_print_field_concat':
                result.value = !entities ? '' :
                    entities.map(function (entity) { return entity.getProperty('name').value; }).join('; ');
                break;
        }
        return Observable_1.Observable.of(result);
    };
    CustomAggregateFunctionsProviderImplService.prototype.loadMaxMin = function (result, entities, aggregateConfig, isMax) {
        var _this = this;
        var valuesToSelectFrom = [];
        if (entities && entities.length) {
            entities.forEach(function (entity) {
                if (entity.getProperty(aggregateConfig.aggregateField).value) {
                    valuesToSelectFrom.push(entity.getProperty(aggregateConfig.aggregateField).value);
                }
            });
        }
        if (!valuesToSelectFrom || !valuesToSelectFrom.length) {
            return Observable_1.Observable.of(result);
        }
        var maxOrMin = valuesToSelectFrom.sort(function (a, b) { return a - b; })[isMax ? valuesToSelectFrom.length - 1 : 0];
        if (aggregateConfig.aggregateFieldType === idm_kb_service_client_js_1.MetaFieldType.DATE_TIME || aggregateConfig.aggregateFieldType === idm_kb_service_client_js_1.MetaFieldType.DATE) {
            return this.currentLanguageId$.pipe(operators_1.switchMap(function (currentLanguageId) {
                return Observable_1.Observable.from(aggregateConfig.aggregateFieldType === idm_kb_service_client_js_1.MetaFieldType.DATE
                    ? _this.localeService.formatDate(maxOrMin.getTime(), currentLanguageId)
                    : _this.localeService.formatDateTime(maxOrMin.getTime(), currentLanguageId))
                    .pipe(operators_1.map(function (formattedDate) {
                    result.value = formattedDate;
                    return result;
                }));
            }));
        }
        result.value = maxOrMin.toString();
        return Observable_1.Observable.of(result);
    };
    CustomAggregateFunctionsProviderImplService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [idm_locale_service_client_js_1.LocaleService,
            idm_session_data_provider_api_js_1.CurrentLanguageProvider])
    ], CustomAggregateFunctionsProviderImplService);
    return CustomAggregateFunctionsProviderImplService;
}());
exports.CustomAggregateFunctionsProviderImplService = CustomAggregateFunctionsProviderImplService;
//# sourceMappingURL=custom-aggregate-functions-provider-impl.service.js.map